import React, {useState} from 'react'
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

// labels
import { REQUIRED } from "../../i18n/i18n";
import {getDateToFormField} from "../../../util/DateTools";

const SpecialOptionComponent = ({
    title,
    content,
    date,
    wishlist,
    enabledDate = false,
    setExternalDate = () => console.warn('With out function'),
    setExternalValue = () => console.warn('With out function')
}) => {
    const [active, setActive] = useState( !!content )
    const [textValue, setTextValue] = useState( content || '')
    const textError = active && !textValue ? true : false

    const [selectedDate, setSelectedDate] = useState( date || '')

    const handleChecked = (e) => {
        const value = e.target.checked

        setActive( value )

        if(!value){
            setTextValue('')
            setExternalValue('')

            return
        }

        if(!textValue)
            setExternalValue(null)
    }

    const handleChange = (e) => {
        const value = e.target.value

        setTextValue(value)
        setExternalValue( value || null )
    }

    const handleChangeDate = e => {
        const date = e.target.value
        setSelectedDate(date)
        setExternalDate(date)
    }

    return <>
        <Row className={'mb-1em'}>
            <Col className={'mt-middle-em'}>
                <FormGroup check>
                    <Input
                        type="checkbox"
                        checked={active}
                        onChange={handleChecked}
                    />
                    {' '}
                    <Label check> {title} </Label>
                </FormGroup><br/>
            </Col>
            {
                enabledDate && <Col>
                    <Input
                        type="date"
                        checked={ active }
                        value={ selectedDate }
                        disabled={ !active }
                        /*min={ getDateToFormField(wishlist?.checkIn) }
                        max={ getDateToFormField(wishlist?.checkOut) }*/
                        onChange={handleChangeDate}
                    />
                </Col>
            }
        </Row>
        <Row className={'mb-1em'}>
            <Col>
                <FormGroup>
                    <Input
                        name='comments'
                        type='textarea'
                        value={ textValue }
                        disabled={ !active }
                        onChange={ handleChange }
                    />
                    { textError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                </FormGroup>
            </Col>
        </Row>
    </>

}

export default SpecialOptionComponent